import React from "react";
import { useLocation } from "react-router-dom";
import SeoHead from "./SiteSeo";
import SiteLayout from "./SiteLayout";
import { CalendlyLink } from "./SiteHeader";
import { NAV, FOOTER_COLUMNS } from "./nav";

function labelFor(path) {
  for (const n of NAV) for (const g of n.groups) for (const [l, h] of g.items) if (h === path) return l;
  for (const c of FOOTER_COLUMNS) for (const [l, h] of c.links) if (h === path) return l;
  return path.split("/").filter(Boolean).pop()?.replace(/-/g, " ").replace(/\b\w/g, (m) => m.toUpperCase()) || "This page";
}

// Branded, noindex holding page for routes in the reconciled map that aren't built yet (Phase 2+).
export default function ComingSoonPage() {
  const { pathname } = useLocation();
  const label = labelFor(pathname);
  return (
    <SiteLayout>
      <SeoHead title={`${label} · Hello Mortgage Team`} description="This page is on its way." path={pathname} noindex />
      <section className="hero" data-testid="coming-soon-page">
        <div className="hero-grid wrap">
          <div>
            <div className="eyebrow">{label}</div>
            <h1 style={{ fontSize: "clamp(3rem,5.5vw,5rem)" }}>This page is on its way.</h1>
            <p>We’re building it right now. In the meantime, the fastest way to get a real answer is a real conversation.</p>
            <div className="actions"><CalendlyLink className="btn" testId="coming-soon-cta">Let's Get This Going</CalendlyLink><a className="textlink" href="/">Back to the homepage</a></div>
            <div className="micro">Free conversation. Clear answers. Zero mortgage-speak.</div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
